import { render, staticRenderFns } from "./ConfirmAddressErrorModal.vue?vue&type=template&id=c2e03b20&"
import script from "./ConfirmAddressErrorModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddressErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAddressErrorModal.vue?vue&type=style&index=0&id=c2e03b20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports